export default "__VITE_ASSET__DgE8zh4V__";